import type { FC, ReactElement } from 'react';
import { useMemo } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const PrivateTableDuplicatePlayerConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const redirectToCasinoLobby = useRedirectToLobbyCallbackConnected();

  const action = [
    <Button
      key="CLOSE"
      tk="CLOSE"
      variant={ButtonVariant.MAIN}
      onClick={() => {
        redirectToCasinoLobby();
      }}
    />,
    <Button
      key="LOBBY_TAKE_A_SEAT"
      tk="LOBBY_TAKE_A_SEAT"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.DuplicatePrivatePlayerSession));
      }}
    />,
  ];

  const messageContent = useMemo(() => {
    return <L10nText tk="POPUP_TAKE_A_SEAT_2" markdown />;
  }, []);

  return (
    <BlockingModalContent title={<L10nText tk="PRIVE_MULTIPLE_SESSIONS" />} actions={action}>
      {messageContent}
    </BlockingModalContent>
  );
};
